import React from 'react'
import { Box, Typography, useTheme, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { formatDate } from '../utils/formatters'
import { getDisplayName } from '../utils/historyHelpers'
import { HistoryItem } from '../types'

interface HistoryItemHeaderProps {
  item: HistoryItem
  isExpanded: boolean
  viewMode: 'by_resource' | 'by_actor'
  onToggle: () => void
}

const HistoryItemHeader: React.FC<HistoryItemHeaderProps> = ({ 
  item, 
  isExpanded, 
  viewMode, 
  onToggle 
}) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const actorEmail = item.actor?.id || ''

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      pb: 1,
      borderBottom: 'none'
    }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          color: theme.palette.text.primary,
          fontSize: 10
        }}
      >
        <i
          className={'fa-light fa-chevron-down'}
          style={{
            cursor: 'pointer',
            transform: isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)',
            transition: 'transform 0.3s ease'
          }}
          onClick={onToggle}
        />
        <Typography
          sx={{
            fontSize: 10,
            color: theme.palette.text.primary
          }}
        >
          {formatDate(item.created_at || item.sent_at, t)}
        </Typography>
      </Box>

      <Box sx={{
        flex: 1,
        mx: 2,
        height: '1px',
        backgroundColor: '#F7F7F7'
      }} />

      <Tooltip 
        title={actorEmail} 
        arrow 
        placement="top"
      >
        <Typography
          sx={{
            fontSize: 10,
            color: theme.palette.text.secondary,
            cursor: 'pointer'
          }}
        >
          {getDisplayName(item, viewMode, t)}
        </Typography>
      </Tooltip>
    </Box>
  )
}

export default HistoryItemHeader
